<template>
  <div class="o-homepage-visualization">
    <div class="o-homepage-visualization__title">
      <h3 class="o-homepage-visualization__heading">
        {{ title }}
      </h3>
      <div class="o-homepage-visualization__subheading">
        {{ subheading }}
      </div>
    </div>

    <OverviewMenu
      :selected-view-id="selectedViewId"
      :dataset="dataset"
      @menu-view-click="setSelectedIdView"
    />

    <div
      :id="selectedViewId + '_tab'"
      :class="[
        'o-homepage-visualization__container',
        isMobile
          ? 'o-homepage-visualization__container--mobile'
          : 'o-homepage-visualization__container--desktop'
      ]"
    >
      <component
        :is="isMobile ? 'OverviewCardMobile' : 'OverviewCardDesktop'"
        v-for="(item, i) in selectedViewDataset"
        :id="item.image.id"
        :key="`${item.image.id}-${i}`"
        :to="item.image.to"
        :datum="item.datum"
        :category-id="item.id"
        :card-class-name="item.cardClassName"
        ratio="full"
        :region="isMobile ? item.image.regionMobile : item.image.regionDesktop"
        :data="item.image.data"
      />
    </div>
  </div>
</template>

<script>
import { breakpointsMixin } from "@thegetty-private/getty-ui";
import { debounce } from "@thegetty-private/getty-ui";
import OverviewCardDesktop from "@/components/molecules/overviewCard/desktop.vue";
import OverviewCardMobile from "@/components/molecules/overviewCard/mobile.vue";
import OverviewMenu from "@/components/molecules/overviewMenu/index.vue";
import overviewDataset from "@/data/overviewDataset.json";
import mobileMixin from "@/mixins/mobileMixin/index.js";

export default {
  name: "HomepageVisualization",
  components: { OverviewMenu, OverviewCardDesktop, OverviewCardMobile },
  mixins: [breakpointsMixin, mobileMixin],
  data() {
    return {
      subheading: this.$t("overview.subheading"),
      title: this.$t("overview.title"),
      isMobile: false,
      /**
       * Current view id
       * @type {String}
       */
      selectedViewId: "era",
      dataset: [],
      /**
       * Indicate if a view section is already been visited or not
       * @type {Object: Object.<String, Boolean>}
       * @example {type: true, era: false, location: false, 'open-content': false}
       */
      viewsStatus: overviewDataset.reduce((acc, curr) => {
        acc[curr.id] = false;
        return acc;
      }, {})
    };
  },
  computed: {
    /**
     * Array of objects that describes the cards content
     *
     * @return {Array}
     */
    selectedViewDataset: function () {
      const selectedDataset = this.dataset.find(
        (datum) => datum.id === this.selectedViewId
      );
      return selectedDataset.data;
    }
  },
  beforeMount() {
    // on every load page, loop on data and choose a random image to show between the one is images array
    const selectedDatasetWithRandomImage = overviewDataset.map((viewDatum) => {
      const { data } = viewDatum;
      const dataWithRandomImage = data.map((cardDatum) => {
        const { images } = cardDatum;
        const randomIndex = Math.floor(Math.random() * images.length);
        const randomImage = images[randomIndex];
        return { ...cardDatum, image: randomImage };
      });
      return { ...viewDatum, data: dataWithRandomImage };
    });

    this.dataset = selectedDatasetWithRandomImage;
  },
  mounted() {
    this.debouncedResize = debounce(this.onResize);
    window.addEventListener("resize", this.debouncedResize);
  },
  destroy() {
    window.removeEventListener("resize", this.debouncedResize);
  },
  methods: {
    /**
     * Called when user clicks on a menu item
     * @param {String} viewId id of the clicked menu item
     */
    setSelectedIdView: function (viewId) {
      this.selectedViewId = viewId;
    }
  }
};
</script>

<style lang="scss">
@import "./index";
</style>
